module.exports = __webpack_public_path__ + "2e46c869ffd9e6982ef42be1ed8d45d1.png";